/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import HolidaysList from "./HolidaysList";
import holidayManager from "services/Holiday/holidayManager";
import { Row } from "components/DataTable";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { dateFormate } from "util/Util";
import * as XLSX from "xlsx"; // Added for client-side export
import { AiOutlineExport } from "react-icons/ai"; // Added for Export Icon

export default function Holidays() {
  const [holidays, setHolidays] = useState<Row[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const { t } = useTranslation();

  // Generate year options (current year and previous/next years)
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 2; i <= currentYear + 1; i++) {
      years.push({ value: i, label: i.toString() });
    }
    return years;
  };

  const yearOptions = generateYearOptions();

  const tableColumns = [
    // { key: "id", label: `Id`, bold: true },
    {
      key: "holidayDate",
      label: `${t("holiday.holidayDate")}`,
      render: (value: any) => dateFormate(String(value)),
    },
    { key: "occasion", label: `${t("holiday.occassion")}` },
    { key: "day", label: `${t("holiday.day")}`, bold: true },
    { key: "year", label: `${t("holiday.year")}` },
    { key: "location", label: `${t("holiday.location")}`, bold: true },
  ];

  useEffect(() => {
    setLoading(true);
    holidayManager
      .getHolidayList(selectedYear)
      .then((res) => {
        const holidayResponses: Row[] = res.data.map((row) => ({
          id: row.holidayId,
          ...row,
        }));
        holidayResponses.sort(
          (a: any, b: any) =>
            new Date(a.holidayDate).getTime() -
            new Date(b.holidayDate).getTime()
        );

        console.log("holidayResponses ", holidayResponses);
        setHolidays(holidayResponses);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching holiday list:", error);
        setLoading(false);
      });
  }, [selectedYear]);

  // Client-side export logic for Holidays
  const handleExport = () => {
    if (!holidays || holidays.length === 0) {
      console.warn("No data available to export");
      return;
    }

    // Map the necessary data fields for Excel
    const exportData = holidays.map((row: any) => ({
      "Holiday Date": dateFormate(String(row.holidayDate)),
      "Occasion": row.occasion || "-",
      "Day": row.day || "-",
      "Year": row.year || "-",
      "Location": row.location || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Auto-size columns slightly for better readability
    worksheet["!cols"] = [
      { wch: 20 }, // Holiday Date
      { wch: 35 }, // Occasion
      { wch: 15 }, // Day
      { wch: 10 }, // Year
      { wch: 20 }, // Location
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `Holidays_${selectedYear}`);

    // Download the file
    XLSX.writeFile(workbook, `Holidays_List_${selectedYear}.xlsx`);
  };

  return (
    <>
      {/* <BreadCrumb BreadCrumbList={BreadCrumbList} /> */}

      <HolidaysList
        data={holidays}
        columns={tableColumns}
        loading={loading}
        // Injecting the stylized export button right before the Year dropdown
        preAddButtons={
          <div className="flex items-center gap-3">
            <button
              onClick={handleExport}
              title="Export Holidays"
              type="button"
              className="inline-flex items-center justify-center h-[38px] px-4 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-500 transition-all shadow-sm"
            >
              <AiOutlineExport size={18} className="mr-2" />
              <span>Export</span>
            </button>
          </div>
        }
        customButton={
          <div className="min-w-[160px]">
            <Select
              options={yearOptions}
              value={yearOptions.find(
                (option) => option.value === selectedYear
              )}
              onChange={(option) => option && setSelectedYear(option.value)}
              placeholder="Select Year"
              isSearchable={false}
              menuPortalTarget={
                typeof document !== "undefined" ? document.body : null
              }
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999, boxShadow: "none" }),
                control: (base) => ({ ...base, boxShadow: "none" }),
              }}
              classNames={{
                control: () =>
                  "!rounded-lg !border-gray-200 dark:!border-gray-600 !bg-white dark:!bg-gray-800 !min-h-[42px]",
                placeholder: () => "!text-gray-400 !text-sm",
                singleValue: () => "!text-gray-900 dark:!text-gray-400 !text-sm",
                menu: () => "!bg-white dark:!bg-gray-800 !border !border-gray-200 dark:!border-gray-600 !rounded-lg !overflow-hidden !mt-2",
                option: ({ isFocused, isSelected }) =>
                  `!text-sm !px-4 !py-2 ${isSelected ? '!bg-blue-700 !text-white' : isFocused ? '!bg-gray-100 dark:!bg-gray-700 !text-gray-900 dark:!text-white' : '!text-gray-700 dark:!text-gray-300'}`
              }}
            />
          </div>
        }
      />
    </>
  );
}